var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Translate } from "../../../../../I18N";
import { Button } from "../../../../Components/UI";


const pxColumnHelper = createColumnHelper();

const TableHeaderContainer = ({ children }) => /*#__PURE__*/
_jsx("span", { className: "text-gray-500 font-semibold text-xs" }, void 0, children);

const TemplateHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Paragraph "), "#"
);

const EntityHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Text")
);

const ActionHeader = () => /*#__PURE__*/
_jsx(TableHeaderContainer, {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Action")
);


const DisplayCell = ({ cell }) => /*#__PURE__*/
_jsx("span", { className: "text-xs font-normal text-gray-900 line-clamp-2 overflow-ellipsis" }, void 0,
cell.getValue()
);


const ParagraphNoCell = ({ cell }) => /*#__PURE__*/
_jsx("span", { className: "text-xs font-medium text-gray-900 text-center flex items-center justify-center" }, void 0,
cell.getValue()
);


const ViewButton = (action) => /*#__PURE__*/
_jsx(Button, { className: "leading-4", styling: "outline", onClick: action }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "View")
);


const tableBuilder = ({ onViewAction }) => [
pxColumnHelper.accessor('rowId', {
  header: TemplateHeader,
  cell: ParagraphNoCell,
  enableSorting: false
}),
pxColumnHelper.accessor('text', {
  header: EntityHeader,
  cell: DisplayCell,
  meta: { headerClassName: 'w-5/6' },
  enableSorting: false
}),
pxColumnHelper.accessor('_id', {
  header: ActionHeader,
  cell: (props) =>
  ViewButton(() => {
    const paragraphId = props.cell.getValue();
    if (paragraphId) {
      onViewAction(paragraphId);
    }
  }),
  enableSorting: false
})];


export { tableBuilder };